import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { IGolfSourceService } from '../../../services/IGolfCourse/igolf-source.service';
import {
  GolfCourse,
  Hole,
  ScoreCardResponse,
  VectorGPSResponse,
} from '../../../model/igolf.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../shared/services/shared.service';
import { customSettings, User } from '../../../model/user.model';
import { MediaService } from '../../../services/media.service';
import { CommonModule, DatePipe, DecimalPipe, isPlatformBrowser } from '@angular/common';
import { MapService } from '../../../services/map/map.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { AskQuestionModel, chat } from '../../../model/chat.model';
import { finalize, forkJoin, shareReplay, Subscription, switchMap } from 'rxjs';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { ChatService } from '../../../services/chat/chat.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../shared/components/confirmation/confirmation.component';
import { FormatChatPipe } from '../../../pipes/format-chat/format-chat.pipe';
import { UserSettingService } from '../../../services/user-setting.service';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { FormsModule } from '@angular/forms';
import { CaddyService } from '../../../services/caddy.service';
import { Caddy } from '../../../model/caddy.model';
import { v4 as uuidv4 } from 'uuid';
import { DragScrollComponent, DragScrollItemDirective } from 'ngx-drag-scroll';
import { RuleAssistModalComponent } from '../../../shared/components/rule-assist-modal/rule-assist-modal.component';
@Component({
  selector: 'app-in-play',
  imports: [
    CommonModule,
    FormsModule,
    TranslatePipe,
    FormatChatPipe,
    LottieComponent,
    DragScrollComponent,
    DragScrollItemDirective,
    RuleAssistModalComponent,
  ],
  providers: [TranslatePipe, DecimalPipe, DatePipe],
  templateUrl: './in-play.component.html',
  styleUrl: './in-play.component.scss',
})
export class InPlayComponent implements OnInit, OnDestroy {
  course: GolfCourse = new GolfCourse();
  id = '';
  user: User = {} as User;
  isGpsEnabled = false;
  speaking = false;
  private mediaRecorder: MediaRecorder | null = null;
  private audioChunks: Blob[] = [];
  audioUrl: string | undefined | null;
  audioBlob: Blob | undefined;
  questionModel: AskQuestionModel = new AskQuestionModel();
  audioQueue: string[] = [];
  isPlaying = false;
  private audio: any;
  chatId: string = '';
  isProcessing = false;
  aiSpeaking = false;
  isBrowser = false;
  answerEnd = true;
  mediaStream: MediaStream | null = null;
  messageSubscription: Subscription = new Subscription();
  activeVoiceChunk = '';
  voiceChunks = 0;
  recordingTimer: any;
  holeNumbers: number[] = [];
  changeUnitModalRef: NgbModalRef | null = null;
  // Earth radius in yards
  private readonly EARTH_RADIUS_YARDS = 3959 * 1760;
  userLatitude: number = 0;
  userLongitude: number = 0;
  watchId: number | null = null;
  position: any = null;
  accuracy: number | null = null;
  holes: Hole[] = [];
  currentHole: Hole = new Hole();
  centerDistance = 0;
  playedHoles: Hole[] = [];
  upcomingHoles: Hole[] = [];
  // unit = 'yard';
  vectorData = {} as VectorGPSResponse;
  conversations: {
    answer: string;
    question: string;
    loading: boolean;
    id: string;
    reaction: string;
    refId?: string;
    route?: string;
  }[] = [];

  submitting: boolean = false;
  buffer: string = '';
  textQuestion = '';
  isLoading = false;
  isCallCaddy = false;
  isVoiceToVoiceChat = false;
  voiceAnswerEnd = false;
  scoreCardData = new ScoreCardResponse();
  private endRoundClicked = false;
  isAutomaticScrolling = false;
  lastScrollTop: number = 0; // Stores the last scrollTop value
  isMuted = false;
  customSetting: customSettings = {
    general: '',
    onCourse: '',
    distance: 'yards',
    onCourseMode: '',
    onCourseAudio: '',
  };
  loadingCourseData = false;
  loadingMessage = false;
  animationOptions: AnimationOptions = {
    path: '/assets/animations/New_AI_Processing.json',
  };
  isInitial = false;
  retryDelay = 500;
  // loadingMichrophone = false;
  accuracyList: any[] = [];
  findingLocation = false;
  caddieSettingsModalRef: NgbModalRef | null = null;
  isCustomSettingSaving = false;
  currentMode = '';
  caddy: Caddy | null = null;
  caddyName = '';

  manualTextQuestion: string = '';
  isActive = false;
  processingOptions: AnimationOptions = {
    path: '/assets/animations/New_AI_Processing.json',
  };
  talkingOptions: AnimationOptions = {
    path: '/assets/animations/New_AI_Talking.json',
  };
  listeningOptions: AnimationOptions = {
    path: '/assets/animations/New_AI_Listening.json',
  };
  toggleActive() {
    this.isActive = !this.isActive;
  }
  openVoiceToVoiceChat = false;
  answerListening = false;
  audioAnswerLoading = false;
  playingIndex = 0;
  showTextQuestionControl = false;
  settingModalRef: NgbModalRef | null = null;
  ruleAssistQuestionObject!: chat;
  mediaElementSource: MediaElementAudioSourceNode | null = null;
  @ViewChild('equalizerCanvas', { static: true }) canvasRef!: ElementRef<HTMLCanvasElement>;
  private ruleAssistModalRef!: NgbModalRef;
  @ViewChild('audioRef') audioRef!: ElementRef<HTMLAudioElement>;
  @ViewChild('myInput') myInput!: ElementRef;
  base64Audio: string | null = null;
  showEqualizer = false;
  recordingFinished = false;
  audioContext!: AudioContext | null;
  isRecording: boolean = false;
  recordingStatus: string = 'Not recording';
  analyser!: AnalyserNode;
  dataArray: any;
  animationFrameId!: any;
  isAudioPlaying = false;
  constructor(
    private iGolfSourceService: IGolfSourceService,
    private _activatedRoute: ActivatedRoute,
    private _sharedService: SharedService,
    private _mapService: MapService,
    private _toasterService: ToasterService,
    @Inject(PLATFORM_ID) private platformId: object,
    private _translatePipe: TranslatePipe,
    private _toaster: ToasterService,
    private _mediaService: MediaService,
    private _chatService: ChatService,
    private _modalService: NgbModal,
    private _router: Router,
    private _userSettingService: UserSettingService,
    private _caddyService: CaddyService,
    private _decimalPipe: DecimalPipe,
    private _cdr: ChangeDetectorRef,
    private _ngZone: NgZone
  ) {
    this._sharedService.loading.set(false);
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
      this.audio = new Audio();
    }
    this.id = this._activatedRoute.snapshot.paramMap.get('id') || '';
    localStorage.setItem('onCourseId', this.id);
  }

  ngOnInit() {
    this.isLoading = true;
    this.isInitial = true;
    // if(this.todaysDate === this.eventDate){
    //   this.getCaddyById('67358cecd7d4862aa89b2d55');
    // }
    if (isPlatformBrowser(this.platformId)) {
      if ('geolocation' in navigator) {
        this.watchId = navigator.geolocation.watchPosition(
          (pos) => {
            this.accuracy = pos.coords.accuracy;
            // console.log('accuracy:', this.accuracy);
            // if (this.accuracy != null && this.accuracy < 5) {
            this.userLatitude = pos.coords.latitude;
            this.userLongitude = pos.coords.longitude;

            if (this.isInitial) {
              this.isLoading = false;
              this.isGpsEnabled = true;
              this.isInitial = false;
              this.loadData();
            } else {
              this.updateCenterDistance();
            }
            // }
            // this.watchLocation();
          },
          (error) => {
            this.handleLocationError(error);
          },
          {
            enableHighAccuracy: true,
            maximumAge: 0,
            timeout: 60000,
          }
        );
      } else {
        this.isLoading = false;
        this._toaster.error(
          this._translatePipe.transform('LocationErrorMessage'),
          this._translatePipe.transform('LocationErrorTitle')
        );
      }
    }
    this.connectWebSocket();
    this._sharedService.user$.subscribe((res) => {
      this.user = res;
      if (
        this.user.caddy &&
        this.user.caddy.image &&
        !this.user.caddy.imageUrl
      ) {
        this._mediaService
          .getMedia([this.user.caddy.image])
          .subscribe((res) => {
            this.user.caddy!.imageUrl = res[0] ? res[0].url : '';
            this._cdr.detectChanges();
          });
      }
      if (this.user.customSettings) {
        this.customSetting = this.user.customSettings;
      }
    });

    this.messageSubscription.add(
      this._chatService.checkOnlockCaddyFeature().subscribe((res) => {
        if (this.id === res.courseId) {
          this.caddyName = res.name;
        }
      })
    );
    this.messageSubscription.add(
      this._chatService.getMessages().subscribe((res) => {
        switch (res.event) {
          case 'ANSWER_CHAT_ID':
            this.chatId = res.data;
            localStorage.setItem('OnCourseChatId', this.chatId);
            break;
          case 'QUESTION_TEXT':
            this.textQuestion = res.data;
            if (this.isVoiceToVoiceChat) {
              this.conversations.push({
                question: this.textQuestion,
                id: '',
                answer: '',
                loading: true,
                reaction: 'none',
              });
              this._cdr.detectChanges();
            }
            break;
          case 'ANSWER_START':
            this.audioQueue = [];
            this.activeVoiceChunk = '';
            this.voiceChunks = 0;
            this.answerEnd = false;
            this.isProcessing = false;
            this.submitting = false;
            this._cdr.detectChanges();
            this.buffer = '';
            if (
              this.customSetting.onCourseAudio === 'on' ||
              this.isVoiceToVoiceChat
            ) {
              this.aiSpeaking = true;
            } else {
              this.isMuted = true;
            }
            this._cdr.detectChanges();
            break;
          case 'ROUTE_INFO':
            this.conversations[this.conversations.length - 1].route = res.data;
            break;
          case 'ANSWER_VOICE_CHUNK':
            if (
              this.customSetting.onCourseAudio === 'on' ||
              this.isVoiceToVoiceChat
            ) {
              this.activeVoiceChunk += res.data;
            }
            break;
          case 'ANSWER_VOICE_CHUNK_END':
            if (this.activeVoiceChunk) {
              this.voiceChunks++;
              this.audioQueue.push(this.activeVoiceChunk);
              this.activeVoiceChunk = '';
              this.playNextInQueue();
            }
            break;
          case 'ANSWER_TEXT_CHUNK':
            this.buffer += res.data;
            // this.submitting = false;
            this.updateMessages(this.buffer);
            break;
          case 'ANSWER_END':
            this.answerEnd = true;
            this.voiceChunks = 0;
            if (!this.aiSpeaking) {
              this.isVoiceToVoiceChat = false;
              this.isCallCaddy = false;
              this.isMuted = false;
              this._cdr.detectChanges();
            }
            this.playNextInQueue();
            break;
          case 'ANSWER_ERROR':
            this.isProcessing = false;
            this.aiSpeaking = false;
            this.submitting = false;
            this.isMuted = false;
            this._cdr.detectChanges();
            this.isVoiceToVoiceChat = false;
            this._toaster.error(
              res.data,
              this._translatePipe.transform('Error')
            );
            break;
          default:
        }
        if (this.isAutomaticScrolling) {
          const container = document.getElementById('conversationChat');
          if (container) {
            container.scrollTo({
              top: container.scrollHeight,
              behavior: 'smooth',
            });
          }
        }
      })
    );
    this.messageSubscription.add(
      this._chatService.audioEnded().subscribe((res) => {
        if (res === true) {
          this.answerListening = false;
        } else if (res === false) {
          this.audioAnswerLoading = false;
          this._cdr.markForCheck();
        }
      })
    );
  }
  updateMessages(message: string) {
    this.conversations[this.conversations.length - 1].loading = false;
    this.conversations[this.conversations.length - 1].answer = message.replace(
      /\n/g,
      '<br>'
    );
    this._cdr.detectChanges();
  }
  async enableLocation(): Promise<void> {
    const gpsEnabled = await this._mapService.checkIfGpsEnabled();
    if (!gpsEnabled) {
      this._toasterService.warning(
        this._translatePipe.transform('LocationEnableMessage'),
        this._translatePipe.transform('Info')
      );
    } else {
      this.isGpsEnabled = true;
    }
  }
  watchLocation() {
    const options = {
      enableHighAccuracy: true,
      maximumAge: 0,
      timeOut: 60000,
    };
    this.watchId = navigator.geolocation.watchPosition(
      (pos) => {
        if (this.userLatitude && this.userLongitude) {
          // const distance = this.calculateDistance(
          //   this.userLatitude,
          //   this.userLongitude,
          //   pos.coords.latitude,
          //   pos.coords.longitude,
          //   'meters'
          // );
          this.accuracy = pos.coords.accuracy;
          // console.log('Accuracy:' + this.accuracy);
          if (this.accuracy != null && this.accuracy < 5) {
            this.userLatitude = pos.coords.latitude;
            this.userLongitude = pos.coords.longitude;
            this.updateCenterDistance();
          }
        }
      },
      (error) => {
        // this.isLoading = false;
        // this.isGpsEnabled = false;
        this.handleLocationError(error);
      },
      options
    );
  }

  private handleLocationError(error: GeolocationPositionError): void {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        this._toaster.error(
          this._translatePipe.transform('LocationDenied'),
          this._translatePipe.transform('Error')
        );
        break;
      case error.POSITION_UNAVAILABLE:
        this._toaster.error(
          this._translatePipe.transform('LocationInfoUnavailable'),
          this._translatePipe.transform('Error')
        );
        break;
      case error.TIMEOUT:
        this._toaster.error(
          this._translatePipe.transform('LocationTimeout'),
          this._translatePipe.transform('Error')
        );
        break;
      default:
        this._toaster.error(
          this._translatePipe.transform('UnknownError'),
          this._translatePipe.transform('Error')
        );
        break;
    }
  }

  loadData() {
    // this.getCourse();
    // this.getTees();
    // this.getGPSDetail();
    this.getCourseData();
    this.chatId = localStorage.getItem('OnCourseChatId') ?? '';
    if (this.chatId) {
      this.getMessagesFromId();
    }
  }
  getCourse() {
    this.iGolfSourceService.getCourseDetailFromId(this.id).subscribe({
      next: (res) => {
        this.course = res;
      },
    });
  }
  getCourseScoreCard() {
    this.iGolfSourceService.getCourseScoreCard(this.id).subscribe({
      next: (res) => {
        // console.log('ScoreCard:' + res);
      },
    });
  }
  getGPSDetail() {
    this.iGolfSourceService.getGpsDetail(this.id).subscribe({
      next: (res) => {
        // console.log('GpsDetail:' + res);
      },
    });
  }
  getCourseData() {
    this.loadingCourseData = true;
    const gpsVector$ = this.iGolfSourceService
      .getGpSVector(this.id)
      .pipe(shareReplay(1));
    const scoreCard$ = this.iGolfSourceService
      .getCourseScoreCard(this.id)
      .pipe(shareReplay(1));
    const course$ = this.iGolfSourceService
      .getCourseDetailFromId(this.id)
      .pipe(shareReplay(1));
    forkJoin({ gpsVector: gpsVector$, scoreCard: scoreCard$, course: course$ })
      .pipe(
        finalize(() => {
          this.loadingCourseData = false;
        })
      )
      .subscribe((res) => {
        this.scoreCardData = res.scoreCard;
        this.vectorData = res.gpsVector;
        this.course = res.course;
        if (!this.isEmpty(this.vectorData.vectorGPSObject)) {
          for (
            let i = 0;
            i < this.vectorData.vectorGPSObject.Holes.Hole.length;
            i++
          ) {
            const mensPar = this.scoreCardData.menScorecardList[0].parHole[i];
            const wmnPar = this.scoreCardData.wmnScorecardList[0].parHole[i];
            this.holes.push({
              hole: this.vectorData.vectorGPSObject.Holes.Hole[i],
              par:
                mensPar == wmnPar ? mensPar.toString() : mensPar + '/' + wmnPar,
            });
          }
          const storedHoleNumber = localStorage.getItem('HoleNumber');
          this.upcomingHoles = [...this.holes];
          if (storedHoleNumber) {
            this.currentHole =
              this.holes.find((x) => x.hole.HoleNumber == +storedHoleNumber) ??
              this.holes[0];
            if (this.currentHole.hole.HoleNumber == this.holes.length) {
              this.playedHoles = [
                this.holes.find(
                  (x) => x.hole.HoleNumber == +storedHoleNumber - 1
                )!,
              ];
              this.upcomingHoles = [...this.holes];
            } else {
              const playedHoles = this.upcomingHoles.splice(
                0,
                +storedHoleNumber - 1
              );
              this.playedHoles = playedHoles.reverse();
              this.upcomingHoles.shift();
            }
          } else {
            this.currentHole = this.upcomingHoles.shift()!;
          }
          // localStorage.setItem("HoleNumber", this.currentHole.hole.HoleNumber.toString());
          const greenCetner =
            this.currentHole.hole.Greencenter?.Shapes?.Shape[0]?.Points.split(
              ' '
            );
          // console.log(
          //   'CourseUser_LatLon:',
          //   this.userLatitude,
          //   this.userLongitude
          // );
          this.centerDistance = this.calculateDistance(
            this.userLatitude,
            this.userLongitude,
            +greenCetner[1],
            +greenCetner[0],
            this.customSetting.distance
          );
        }
      });
  }
  updateCenterDistance() {
    if (this.currentHole) {
      const greenCetner =
        this.currentHole.hole.Greencenter?.Shapes?.Shape[0]?.Points.split(' ');
      if (greenCetner) {
        this.centerDistance = this.calculateDistance(
          this.userLatitude,
          this.userLongitude,
          +greenCetner[1],
          +greenCetner[0],
          this.customSetting.distance
        );
        this._cdr.detectChanges();
      }
    }
  }

  isEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }

  getTees() {
    this.iGolfSourceService.getTees(this.id).subscribe({
      next: (res) => {
        // console.log('Tees', res);
      },
    });
  }
  toggleToSpeakPause() {
    if (!this.speaking) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          this.mediaStream = stream;
          this.mediaRecorder = new MediaRecorder(stream);
          this.mediaRecorder.ondataavailable = (event: BlobEvent) => {
            this.audioChunks.push(event.data);
          };

          this.mediaRecorder.onstop = () => {
            this.audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
            this.audioUrl = URL.createObjectURL(this.audioBlob);
            this.audioChunks = [];
            if (this.mediaStream) {
              this.mediaStream.getTracks().forEach((track) => {
                track.stop(); // Stops the media track (audio in this case)
              });
            }
            this.submitAudioQuestion();
          };
          // Start recording if MediaRecorder is available
          if (this.mediaRecorder) {
            this.audioChunks = [];
            this.mediaRecorder.start();

            // Automatically stop recording after 2 minutes (120000 ms)
            this.recordingTimer = setTimeout(() => {
              if (
                this.mediaRecorder &&
                this.mediaRecorder.state === 'recording'
              ) {
                this.speaking = false;
                this.isProcessing = true;
                this.mediaRecorder.stop();
              }
            }, 120000); // 120 seconds = 2 minutes
            this.speaking = true;
            this.isVoiceToVoiceChat = true;
            this.isAutomaticScrolling = true;
          }
        })
        .catch((error) => {
          let errorMessage = 'AccessingMicrophoneError';
          if (
            error.name === 'NotAllowedError' ||
            error.name === 'PermissionDeniedError'
          ) {
            errorMessage = 'MicrophoneAccessDeniedError';
          }
          this._toaster.error(
            this._translatePipe.transform(errorMessage),
            this._translatePipe.transform('Error')
          );
        });
    } else {
      this.stopRecording();
    }
  }
  submitAudioQuestion() {
    this.buffer = '';
    // call api
    if (!this.audioBlob) {
      return this._toaster.error(
        this._translatePipe.transform('AudioRequired'),
        this._translatePipe.transform('Error')
      );
    }
    if (this.audio) {
      this.audio.pause();
      this.audio.src = '';
      this.audio.load();
    }
    this.submitting = true;
    this.accuracyList = [];
    const maxDuration = 6000; // 6 seconds
    const startTime = Date.now();
    const checkAccuracy = () => {
      if (this.accuracy != null) {
        // Check if the accuracy value already exists in the list
        const exists = this.accuracyList.some(
          (entry) => entry.accuracy === this.accuracy
        );
        if (!exists) {
          // Store accuracy with corresponding coordinates
          this.accuracyList.push({
            accuracy: this.accuracy,
            latitude: this.userLatitude,
            longitude: this.userLongitude,
          });
        }
      }
      // If accuracy is below the threshold, proceed
      if (this.accuracy != null && this.accuracy < 5) {
        this.submitAudioQuestionLogic(this.userLatitude, this.userLongitude); // Execute the main logic
        return;
      }
      // Check if the maximum duration is exceeded
      if (Date.now() - startTime > maxDuration) {
        // Find the lowest accuracy value in the stored data
        const bestEntry = this.accuracyList.reduce((best, current) => {
          return current.accuracy < best.accuracy ? current : best;
        });
        // Use the best accuracy and its coordinates
        // console.log('Best Accuracy:', bestEntry.accuracy);
        // console.log(
        //   'Best Coordinates:',
        //   bestEntry.latitude,
        //   bestEntry.longitude
        // );
        this.submitAudioQuestionLogic(bestEntry.latitude, bestEntry.longitude); // Execute the main logic with the best data
        return;
      }
      // Retry if the duration is within the limit
      setTimeout(checkAccuracy, this.retryDelay);
    };
    checkAccuracy();
  }
  submitAudioQuestionLogic(lat: number, long: number) {
    const fileName = this.generateUniqueFileName();
    this._mediaService
      .getMediaUrls(fileName)
      .pipe(
        switchMap((response1) => {
          this.questionModel.audioQuestion = response1[0].get?.url!;
          return this._mediaService.uploadMediaToS3(
            response1[0].put?.url!,
            this.audioBlob!
          );
        })
      )
      .subscribe({
        next: (res) => {
          this.audioBlob = undefined;
            this.closeRecording();
          // update the center distance with best accuracy value
          // Calculate Distance
          const greenCenter =
            this.currentHole.hole.Greencenter?.Shapes?.Shape[0]?.Points.split(
              ' '
            );

          this.centerDistance = this.calculateDistance(
            lat,
            long,
            +greenCenter[1],
            +greenCenter[0],
            this.customSetting.distance
          );

          this.questionModel.chatId = this.chatId;
          this.questionModel.processType = 'QA-ON-COURSE-VOICE';
          this.questionModel.clientLocation = `${lat},${long}`;
          this.questionModel.holeNumber = this.currentHole.hole.HoleNumber;
          this.questionModel.courseId = this.id;
          this._chatService.askQuestionV2(this.questionModel);
        },
        error: (error) => {
          this.isProcessing = false;
          this.speaking = false;
          this.submitting = false;
          this.isVoiceToVoiceChat = false;
        },
      });
  }
 stopRecording() {
    if (this.mediaRecorder && this.isRecording) {
      this.mediaRecorder.stop(); // triggers `onstop` where cleanup already happens
      this.isRecording = false;
      this.recordingFinished = true;
      this.recordingStatus = 'Not recording';
    }

    // Ensure we stop the visualizer animation
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }

    // Close audio context if still open
    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close();
    }
  }
  stopTalking() {
    this.aiSpeaking = false;
    if (!this.answerEnd) {
      this.isMuted = true;
    }
    if (this.answerEnd) {
      this.isVoiceToVoiceChat = false;
      this.isCallCaddy = false;
    }
    this.stopAudio();
  }

  startTalking() {
    this.aiSpeaking = true;
    this.isMuted = false;

    this.playNextInQueue();
  }
  playNextInQueue(): void {
    if (!this.aiSpeaking) return;
    if (this.isPlaying || this.audioQueue.length === 0) {
      if (this.audioQueue.length === 0 && this.answerEnd) {
        this.aiSpeaking = false;
        this.isMuted = false;
        this.isCallCaddy = false;
        this.isVoiceToVoiceChat = false;
        this.isMuted = false;
        this._cdr.detectChanges(); // Ensure the view updates
      }
      return;
    }
    const nextAudioUrl = this.audioQueue.shift();
    if (nextAudioUrl) {
      let blob = this.base64ToBlob(nextAudioUrl);
      let audioUrl = URL.createObjectURL(blob);
      this.playAudio(audioUrl);
    }
  }
  playAudio(audioUrl: any): void {
    this.isPlaying = true;
    this.audio.src = audioUrl;
    this.audio.load();
    this.audio
      .play()
      .then(() => {})
      .catch((error: any) => {
        this.isPlaying = false;
        this.playNextInQueue(); // Try to play the next in queue
      });

    this.audio.onended = () => {
      this.isPlaying = false;
      this.playNextInQueue(); // Play the next audio in queue
    };
  }
  stopAudio() {
    this.audio.pause();
    this.audioQueue = [];
    this.isPlaying = false;
  }
  generateUniqueFileName(): string {
    const timestamp = Date.now();
    // Generate a random number
    const randomNum = Math.floor(Math.random() * 1e9);
    // Combine timestamp and random number to create a unique identifier
    const uniqueIdentifier = `${timestamp}-${randomNum}`;
    // Construct the unique filename with the file extension
    const uniqueFileName = `${uniqueIdentifier}.mp3`;
    return uniqueFileName;
  }
  base64ToBlob(base64: string): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'audio/wav' });
  }

  callCaddy(): void {
    this.isCallCaddy = true;
    this.findingLocation = true;
    this.accuracyList = []; // Array to store accuracy and coordinates
    const maxDuration = 6000; // 6 seconds
    const startTime = Date.now();
    const checkAccuracy = () => {
      if (this.accuracy != null) {
        // Check if the accuracy value already exists in the list
        const exists = this.accuracyList.some(
          (entry) => entry.accuracy === this.accuracy
        );
        if (!exists) {
          // Store accuracy with corresponding coordinates
          this.accuracyList.push({
            accuracy: this.accuracy,
            latitude: this.userLatitude,
            longitude: this.userLongitude,
          });
        }
      }
      // If accuracy is below the threshold, proceed
      if (this.accuracy != null && this.accuracy < 5) {
        this.findingLocation = false;
        this.callCaddyLogic(this.userLatitude, this.userLongitude); // Execute the main logic
        return;
      }
      // Check if the maximum duration is exceeded
      if (Date.now() - startTime > maxDuration) {
        // Find the lowest accuracy value in the stored data
        const bestEntry = this.accuracyList.reduce((best, current) => {
          return current.accuracy < best.accuracy ? current : best;
        });
        // Use the best accuracy and its coordinates
        this.findingLocation = false;
        this.callCaddyLogic(bestEntry.latitude, bestEntry.longitude); // Execute the main logic with the best data
        return;
      }
      // Retry if the duration is within the limit
      setTimeout(checkAccuracy, this.retryDelay);
    };
    checkAccuracy();
  }

  callCaddyLogic(
    lat: number,
    lon: number,
    manualTextQuestion: string = ''
  ): void {
    this.buffer = '';
    // this.isCallCaddy = true;
    this.answerEnd = false;
    this.submitting = true;
    this.questionModel = new AskQuestionModel();
    this.questionModel.chatId = this.chatId;

    // Use data from watchPosition
    this.questionModel.clientLocation = `${lat},${lon}`;
    this.questionModel.holeNumber = this.currentHole.hole.HoleNumber;
    this.questionModel.courseId = this.id;

    // Calculate Distance
    const greenCenter =
      this.currentHole.hole.Greencenter?.Shapes?.Shape[0]?.Points.split(' ');

    this.centerDistance = this.calculateDistance(
      lat,
      lon,
      +greenCenter[1],
      +greenCenter[0],
      this.customSetting.distance
    );
    if (manualTextQuestion) {
      this.questionModel.processType = 'QA-ON-COURSE';
      this.questionModel.textQuestion = manualTextQuestion;
      this.conversations.push({
        question: manualTextQuestion,
        id: '',
        answer: '',
        loading: true,
        reaction: 'none',
      });
    } else {
      const textQuestion = `${this._translatePipe.transform(
        'CallCaddyQuestion'
      )} ${this.currentHole.hole.HoleNumber} - ${this._decimalPipe.transform(
        this.centerDistance,
        '1.0-0'
      )} ${
        this.customSetting.distance === 'yards'
          ? this._translatePipe.transform('Y')
          : this._translatePipe.transform('M')
      } ${this._translatePipe.transform('CallCaddyQuestionEnd')}`;

    this.questionModel.processType = 'QA-ON-COURSE-CADDY';
      this.questionModel.textQuestion = `Caddie Advice - Hole ${
        this.currentHole.hole.HoleNumber
      } - ${this._decimalPipe.transform(this.centerDistance, '1.0-0')} ${
        this.customSetting.distance === 'yards'
          ? this._translatePipe.transform('Y')
          : this._translatePipe.transform('M')
      } to the hole`;
      this.conversations.push({
        question: textQuestion,
        id: '',
        answer: '',
        loading: true,
        reaction: 'none',
      });
    }

    // Make the API Call
    this._chatService.askQuestionV2(this.questionModel);

    this.isAutomaticScrolling = true;
    this._cdr.detectChanges();
  }

  connectWebSocket() {
    if (isPlatformBrowser(this.platformId)) {
      this._ngZone.runOutsideAngular(() => {
        this._chatService
          .onListenWebsocket()
          .then(() => {
            // socket connected succefully .
          })
          .catch((error) => {
            this._toaster.error(
              this._translatePipe.transform('SocketConnectionError'),
              this._translatePipe.transform('Error')
            );
            // console.error('Failed to connect to WebSocket:', error);
          });
      });
    }
  }

  reinitializeWebSocket(): void {
    this._chatService.disconnectWebSocket();
    this.connectWebSocket();
  }
  nextHole() {
    if (this.upcomingHoles.length == 1) {
      this.playedHoles = [this.currentHole];
      this.currentHole = this.upcomingHoles[0];
      this.upcomingHoles = [...this.holes];
      localStorage.setItem(
        'HoleNumber',
        this.currentHole.hole.HoleNumber.toString()
      );
    } else {
      if (this.upcomingHoles.length == this.holes.length) {
        this.playedHoles.pop();
        this.currentHole = this.upcomingHoles.shift()!;
      } else {
        this.playedHoles.unshift(this.currentHole); // adds element to the beginning
        this.currentHole = this.upcomingHoles.shift()!; // remove first element
      }
      localStorage.setItem(
        'HoleNumber',
        this.currentHole.hole.HoleNumber.toString()
      );
      const greenCetner =
        this.currentHole.hole.Greencenter.Shapes.Shape[0].Points.split(' ');
      this.centerDistance = this.calculateDistance(
        this.userLatitude,
        this.userLongitude,
        +greenCetner[1],
        +greenCetner[0],
        this.customSetting.distance
      );
      this._cdr.detectChanges();
    }
  }
  prevHole() {
    if (
      this.playedHoles.length == 1 &&
      this.playedHoles[0].hole.HoleNumber == this.holes.length - 1
    ) {
      this.currentHole = this.playedHoles[0];
      const playedHoles = this.holes.slice(
        0,
        this.currentHole.hole.HoleNumber - 1
      );
      this.playedHoles = playedHoles.reverse();
      this.upcomingHoles = this.holes.slice(this.currentHole.hole.HoleNumber);
      localStorage.setItem(
        'HoleNumber',
        this.currentHole.hole.HoleNumber.toString()
      );
    } else {
      this.upcomingHoles.unshift(this.currentHole);
      this.currentHole = this.playedHoles.shift()!;
      localStorage.setItem(
        'HoleNumber',
        this.currentHole.hole.HoleNumber.toString()
      );
    }

    const greenCetner =
      this.currentHole.hole.Greencenter.Shapes.Shape[0].Points.split(' ');
    this.centerDistance = this.calculateDistance(
      this.userLatitude,
      this.userLongitude,
      +greenCetner[1],
      +greenCetner[0],
      this.customSetting.distance
    );
    this._cdr.detectChanges();
  }
  // Function to convert degrees to radians
  degreesToRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
  }
  // Function to calculate the distance between two coordinates in yards
  calculateDistance(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
    unit: string
  ): number {
    const R = 6371000; // Radius of the Earth in meters
    const dLat = this.degreesToRadians(lat2 - lat1);
    const dLon = this.degreesToRadians(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.degreesToRadians(lat1)) *
        Math.cos(this.degreesToRadians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let distance = R * c; // Distance in meters by default

    // Convert distance to yards if needed
    if (this.customSetting.distance === 'yards') {
      distance *= 1.09361; // Convert meters to yards (1 meter ≈ 1.09361 yards)
    }
    return distance;
  }
  endRound() {
    const modalRef = this._modalService.open(ConfirmationComponent, {
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.message = 'EndRoundConfirmation';
    modalRef.componentInstance.confirmText = 'EndRound';
    modalRef.componentInstance.cancelText = 'Return';
    modalRef.componentInstance.title = 'ConfirmEndRound';

    modalRef.result.then(
      (result) => {
        if (result) {
          this.endRoundClicked = true;
          // navigate to course list
          this._router.navigate(['/']);
        }
      },
      (reason) => {
        // User dismissed the modal
        // console.log('Action dismissed');
      }
    );
  }

  openChangeUnit(content: any) {
    this.changeUnitModalRef = this._modalService.open(content, {
      backdrop: 'static',
      centered: true,
    });
  }
  openCaddieSettingsModal(content: any) {
    this.caddieSettingsModalRef = this._modalService.open(content, {
      backdrop: 'static',
      centered: true,
    });
  }

  changeUnit(type: string) {
    if (type === this.customSetting.distance) {
      this.changeUnitModalRef?.dismiss();
      return;
    } else {
      this.customSetting.distance = type;
      this._userSettingService.customize(this.customSetting).subscribe({
        next: (res) => {
          if (type === 'yards') {
            this.centerDistance = +this.centerDistance * 1.09361;
          } else {
            this.centerDistance = +this.centerDistance * 0.9144;
          }
          this.user.customSettings = this.customSetting;
          this._sharedService.setUser(this.user);
          this.changeUnitModalRef?.dismiss();
          this._cdr.detectChanges();
        },
      });
    }
  }
  getMessagesFromId() {
    this.loadingMessage = true;
    this._chatService
      .getMessageFromId(this.chatId, 100, 1)
      .pipe(
        finalize(() => {
          this.loadingMessage = false;
        })
      )
      .subscribe({
        next: (res) => {
          res.results = res.results.reverse();
          res.results
            .filter((rs: any) => rs.role === 'assistant')
            .forEach((item: any, index: number) => {
              if (item.role === 'assistant') {
                const questionIndex = res.results.findIndex(
                  (lm: any) => lm.id === item.questionRef
                );
                if (questionIndex !== -1) {
                  this.conversations.push({
                    answer: item.content,
                    question: res.results[questionIndex].content,
                    loading: false,
                    id: res.results[questionIndex].id,
                    reaction: res.results[questionIndex].reaction,
                  });
                }
              }
            });
        },
      });
  }
  get showCaddyAdvice(): boolean {
    return (
      !this.speaking &&
      !this.isProcessing &&
      !this.aiSpeaking &&
      !this.isMuted &&
      !this.submitting &&
      !this.isVoiceToVoiceChat &&
      !this.findingLocation
    );
  }

  get showProcessing(): boolean {
    return this.isProcessing || this.submitting;
  }

  get showVoiceBlock(): boolean {
    return (
      !this.speaking &&
      (!this.aiSpeaking || !this.isCallCaddy) &&
      !this.isVoiceToVoiceChat
    );
  }
  onScroll(): void {
    const container = document.getElementById('conversationChat');
    if (container) {
      const currentScrollTop = container.scrollTop;
      // Detect scroll direction
      if (currentScrollTop < this.lastScrollTop) {
        this.isAutomaticScrolling = false;
      }
      this.lastScrollTop = currentScrollTop;
    }
  }
  translateOnCourseAdvice1(key: string): string {
    return this._translatePipe
      .transform(key)
      .replace('{userName}', this.user.name)
      .replace('{courseName}', this.course.courseName)
      .replace('{caddieName}', this.caddy?.name ?? '');
  }

  getHoleNumber(key: string, holeNumber: number): string {
    return this._translatePipe
      .transform(key)
      .replace('{number}', holeNumber.toString());
  }
  updateCustomSetting() {
    this.isCustomSettingSaving = true;
    this._userSettingService
      .customize(this.customSetting)
      .pipe(
        finalize(() => {
          this.isCustomSettingSaving = false;
        })
      )
      .subscribe({
        next: (res) => {
          this.user.customSettings = this.customSetting;
          this._sharedService.setUser(this.user);
          this.caddieSettingsModalRef?.dismiss();
          this._cdr.detectChanges();
        },
      });
  }
  getCaddyById(id: string): void {
    this._caddyService.getById(id).subscribe({
      next: (res) => {
        this.caddy = res;
        if (res.image) {
          this._mediaService.getMedia([res.image]).subscribe((res) => {
            if (this.caddy) {
              this.caddy.imageUrl = res[0] ? res[0].url : '';
            }
          });
        }
      },
    });
  }
  sendManualTextQuestion() {
    if (!this.manualTextQuestion.trim()) {
      return this._toaster.error('Please enter a question', 'Error');
    }
    const textQuestion = this.manualTextQuestion.trim();
    this.manualTextQuestion = ''; // Clear the input field
    this.submitting = true;
    this.findingLocation = true;
    this.accuracyList = []; // Array to store accuracy and coordinates
    const maxDuration = 6000; // 6 seconds
    const startTime = Date.now();
    const checkAccuracy = () => {
      if (this.accuracy != null) {
        // Check if the accuracy value already exists in the list
        const exists = this.accuracyList.some(
          (entry) => entry.accuracy === this.accuracy
        );
        if (!exists) {
          // Store accuracy with corresponding coordinates
          this.accuracyList.push({
            accuracy: this.accuracy,
            latitude: this.userLatitude,
            longitude: this.userLongitude,
          });
        }
      }
      // If accuracy is below the threshold, proceed
      if (this.accuracy != null && this.accuracy < 5) {
        this.findingLocation = false;
        this.showTextQuestionControl = false;
        this.callCaddyLogic(
          this.userLatitude,
          this.userLongitude,
          textQuestion
        ); // Execute the main logic
        return;
      }
      // Check if the maximum duration is exceeded
      if (Date.now() - startTime > maxDuration) {
        // Find the lowest accuracy value in the stored data
        const bestEntry = this.accuracyList.reduce((best, current) => {
          return current.accuracy < best.accuracy ? current : best;
        });
        // Use the best accuracy and its coordinates
        this.findingLocation = false;
        this.showTextQuestionControl = false;
        this.callCaddyLogic(
          bestEntry.latitude,
          bestEntry.longitude,
          textQuestion
        ); // Execute the main logic with the best data
        return;
      }
      // Retry if the duration is within the limit
      setTimeout(checkAccuracy, this.retryDelay);
    };
    checkAccuracy();
  }
  addReaction(reaction: string, index: number, messageId: any) {
    if (this.conversations[index].reaction === reaction) {
      this.conversations[index].reaction = '';
      reaction = 'none';
    } else {
      this.conversations[index].reaction = reaction;
    }

    this._chatService
      .addReactionTotheMessage(messageId, reaction)
      .subscribe((res) => {
        res;
      });
  }
  hearAnswer(text: any, index: number) {
    if (this.answerListening && this.playingIndex === index) {
      this.stopListening(index);
      return;
    }
    this.playingIndex = index;
    this.audioAnswerLoading = true;
    this.answerListening = true;
    const id = uuidv4();
    this.conversations[index].refId = id;
    this._chatService.textToAudio(text, id);
  }
  stopListening(index: number) {
    if (this.conversations[index].refId) {
      this._chatService.stopThisAudio(this.conversations[index].refId);
      this.audioAnswerLoading = false;
      this.answerListening = false;
    }
  }
  ngOnDestroy(): void {
    if (!this.endRoundClicked) {
      const leaveTime = new Date().toISOString();
      localStorage.setItem('onCourseLeaveTime', leaveTime);
    } else {
      localStorage.removeItem('onCourseLeaveTime');
      localStorage.removeItem('HoleNumber');
      localStorage.removeItem('onCourseId');
      localStorage.removeItem('OnCourseChatId');
    }
    if (this.watchId !== null) {
      navigator.geolocation.clearWatch(this.watchId); // Stop geolocation tracking
    }
    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
    // this._chatService.disconnectWebSocket();
  }
  closeVoiceToVoiceChat() {
    this.openVoiceToVoiceChat = false;
    this.isVoiceToVoiceChat = false;
    this.stopAudio();
  }
  openSettingModal(content: any) {
    this.settingModalRef = this._modalService.open(content, {
      backdrop: 'static',
      centered: true,
    });
  }
  saveSettings() {
    this._userSettingService.customize(this.customSetting).subscribe({
      next: (res) => {
        this.settingModalRef?.dismiss();
        this.user!.customSettings = this.customSetting;
        this._sharedService.setUser(this.user!);
      },
    });
  }
  openRuleAssistModal(content: any, index: number) {
    this.ruleAssistQuestionObject = this.conversations[index];
    this.ruleAssistModalRef = this._modalService.open(content, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-rule-assist',
    });
  }
  closeRuleAssistModal() {
    this.ruleAssistModalRef?.dismiss();
  }
  showTextQuestionControlInput() {
    this.showTextQuestionControl = true;
    this.manualTextQuestion = '';
    // Wait for input to be rendered
    setTimeout(() => {
      this.myInput?.nativeElement.focus();
    });
    this._cdr.detectChanges();
  }
  hideTextQuestionControl() {
    setTimeout(() => {
      this.showTextQuestionControl = false;
      this.manualTextQuestion = '';
      this._cdr.detectChanges();
    }, 200); // Delay to allow click on related elements
  }
  async startRecording() {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    // Setup MediaRecorder (optional for recording)
    this.mediaRecorder = new MediaRecorder(stream);
    this.audioChunks = [];
    this.base64Audio = null;

    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) this.audioChunks.push(event.data);
    };

    this.mediaRecorder.onstop = () => {
      this.audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
      this.audioUrl = URL.createObjectURL(this.audioBlob);
      this.audioRef.nativeElement.src = this.audioUrl;

      const audio = this.audioRef.nativeElement;

      audio.src = this.audioUrl;
      audio.load();
      this._cdr.markForCheck();

      audio.addEventListener(
        'canplaythrough',
        () => {
          this.recordingFinished = true;
        },
        { once: true }
      ); // <- This ensures it only runs once
      // this.convertToBase64(audioBlob);
      stream.getTracks().forEach((track) => track.stop());
      if (this.audioContext && this.audioContext.state !== 'closed') {
        this.audioContext
          .close()
          .catch((err) => console.error('Error closing AudioContext:', err));
      }
      cancelAnimationFrame(this.animationFrameId);
    };

    this.mediaRecorder.start();
    this.isRecording = true;
    this.isVoiceToVoiceChat = true;
    this.recordingStatus = 'Recording...';
    this.showEqualizer = true;

    // Setup Web Audio API
    this.audioContext = new AudioContext();
    const source = this.audioContext.createMediaStreamSource(stream);
    this.analyser = this.audioContext.createAnalyser();
    this.analyser.fftSize = 64;

    const bufferLength = this.analyser.frequencyBinCount;
    this.dataArray = new Uint8Array(bufferLength);

    source.connect(this.analyser);

    this.animateEqualizer();
  }
  animateEqualizer() {
    const canvas = this.canvasRef?.nativeElement;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;

    const centerY = height / 1.8;
    const bufferLength = this.dataArray.length;
    const gap = 5; // Set desired gap here
    const barWidth = (width / bufferLength) * 0.7;

    const draw = () => {
      this.animationFrameId = requestAnimationFrame(draw);

      this.analyser.getByteFrequencyData(this.dataArray);

      ctx!.clearRect(0, 0, width, height);
      ctx!.lineJoin = 'round';
      ctx!.lineCap = 'round';

      for (let i = 0; i < bufferLength; i++) {
        const x = i * (barWidth + gap);

        // Base height from data
        let rawHeight = this.dataArray[i];

        // Calculate distance from center to scale height
        const distanceFromCenter = Math.abs(i - bufferLength / 2);
        const scale = 1 - distanceFromCenter / (bufferLength / 2); // 1 at center, 0 at edge
        const adjustedHeight = rawHeight * scale * 0.8; // 0.8 = max height factor

        const barHeight = Math.min(adjustedHeight, 50);

        ctx!.fillStyle = '#000'; // deep navy blue from your image

        // Draw bar centered vertically (up and down)
        this.drawRoundedRect(
          ctx!,
          x,
          centerY - barHeight / 2,
          barWidth,
          barHeight,
          4
        ); // 4px corner radius
      }
    };

    draw();
  }

  drawRoundedRect(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    radius: number
  ) {
    const r = Math.min(radius, height / 2, width / 2); // Avoid over-rounding
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + width - r, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + r);
    ctx.lineTo(x + width, y + height - r);
    ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    ctx.lineTo(x + r, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
    ctx.fill();
  }
  closeRecording() {
    this.recordingFinished = false;
    this.showEqualizer = false;
    this.audioUrl = null;
    this.base64Audio = null;

    // Stop playback if any
    this.audioRef.nativeElement.pause();
    this.audioRef.nativeElement.src = ''; // Fully unload audio
    this.audioRef.nativeElement.load();

    // Stop equalizer animation
    this.stopPlaybackEqualizer();

    // Disconnect mediaElementSource if exists
    if (this.mediaElementSource) {
      try {
        this.mediaElementSource.disconnect();
      } catch (e) {
        console.warn('mediaElementSource already disconnected or invalid', e);
      }
      this.mediaElementSource = null;
    }

    // Close audioContext if not already closed
    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close().then(() => {
        this.audioContext = null;
      });
    }
  }

  stopPlaybackEqualizer() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }
  async onPlay() {
    this.startPlaybackEqualizer();

    const audio = this.audioRef.nativeElement;

    try {
      // Resume audio context if suspended
      if (this.audioContext?.state === 'suspended') {
        await this.audioContext.resume();
      }

      await audio.play();
    } catch (err) {
      console.error('Playback error:', err);
    }
  }

  onPause() {
    const audioElement = this.audioRef?.nativeElement;
    if (audioElement) {
      audioElement.pause();
      this.onPauseOrEnd();
    }
  }

  onAudioPlay() {
    this.isAudioPlaying = true;
    console.log(this.isAudioPlaying);
  }
  onPauseOrEnd() {
    this.isAudioPlaying = false;
    this.stopPlaybackEqualizer();
  }
    // Call this when user clicks play
  startPlaybackEqualizer() {
    if (!this.audioContext || this.audioContext.state === 'closed') {
      this.audioContext = new AudioContext();
      this.mediaElementSource = null; // Reset, since context is new
    }

    const audioElement = this.audioRef.nativeElement;

    if (!this.mediaElementSource) {
      this.mediaElementSource = this.audioContext.createMediaElementSource(audioElement);

      this.analyser = this.audioContext.createAnalyser();
      this.analyser.fftSize = 64;
      const bufferLength = this.analyser.frequencyBinCount;
      this.dataArray = new Uint8Array(bufferLength);

      this.mediaElementSource.connect(this.analyser);
      this.analyser.connect(this.audioContext.destination);
    }

    this.animateEqualizer();
  }
}
